import { DictionaryEntry } from "@sdbn/common";
import { MasterDetailListEntry } from "@sdbn/common";

export enum TaskExecutionType {
  ONCE = 'ONCE', EACH_TIME = 'EACH_TIME'
}
export enum TaskType {
  CHECK = 'CHECK', MESSAGE = 'MESSAGE', DOCUMENT = 'DOCUMENT', PICTURE = 'PICTURE', ATTRIBUTE_CHANGE = 'ATTRIBUTE_CHANGE', PICTURE_SERIES = 'PICTURE_SERIES'
}

export class DocumentTemplate {
  id: number;
  nameDictionaryKey: string;
}

export class Task implements MasterDetailListEntry {
  id: number;
  nameDictionaryKey: string;
  translatedLabel: string;

  constructor(tool: any) {
    this.id = tool.id;
    this.nameDictionaryKey = tool.nameDictionaryKey;
  }

  public get listTitle(): string {
    return this.translatedLabel;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }

}

export class TaskDetails {
  id: number;
  name: DictionaryEntry;
  type: TaskType;
  message: DictionaryEntry;
  executionType: TaskExecutionType;
  sortOrder: string;
  documentTemplate: DocumentTemplate;
  processingHint: string;
  orderReferenceOld: string;
  orderReferenceNew: string;

  constructor(details?: Partial<TaskDetails>) {
    this.id = details?.id;
    this.name = new DictionaryEntry(details?.name);
    this.type = details?.type;
    this.message = new DictionaryEntry(details?.message);
    this.executionType = details?.executionType;
    this.sortOrder = details?.sortOrder;
    this.documentTemplate = details?.documentTemplate;
    this.processingHint = details?.processingHint;
    this.orderReferenceOld = details?.orderReferenceOld;
    this.orderReferenceNew = details?.orderReferenceNew;
  }
}

export class DeviceProperty {

  deviceId: string;
  deviceType: string;
  key: string;
  value: string;

  constructor(property?: Partial<DeviceProperty>) {
    if (property != null) {
      this.deviceId = property.deviceId;
      this.deviceType = property.deviceType;
      this.key = property.key;
      this.value = property.value;
    }
  }


}
